<template>
  <div>
    <img
      @click="toggle()"
      :src="getSelectedImage()"
      class="is_watch_image operation_icon"
    />
  </div>
</template>
<script>
export default {
  name: 'isWatch',
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      is_watch: this.payload.is_watch
    }
  },
  methods: {
    async toggle () {
      if (this.payload.resource_type == 'Applicant') {
        return
      }
      const is_watch = !this.is_watch
      await this.$network_utils.updatePosition({ position_id: this.payload.id, is_watch: is_watch })
      this.is_watch = is_watch
    },
    getSelectedImage () {
      return this.is_watch == true ? '/is_watch_full.png' : '/is_watch_not_full.png'
    }
  }
}
</script>
<style scoped>
  .is_watch_image{
    max-width: 30px;
  }
</style>
